module.exports = __webpack_public_path__ + "img/line_06.642e8775.jpg";